import { render, staticRenderFns } from "./UserLimitsModal.vue?vue&type=template&id=7b8b1cd8&scoped=true&"
import script from "./UserLimitsModal.vue?vue&type=script&lang=js&"
export * from "./UserLimitsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserLimitsModal.vue?vue&type=style&index=0&id=7b8b1cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b1cd8",
  null
  
)

export default component.exports